import { render, staticRenderFns } from "./DocUpload.vue?vue&type=template&id=f4953e72"
import script from "./DocUpload.vue?vue&type=script&lang=js"
export * from "./DocUpload.vue?vue&type=script&lang=js"
import style0 from "./DocUpload.vue?vue&type=style&index=0&id=f4953e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports